<template>
  <v-card>
    <v-card-text
      class="branch-list"
    >
      <span role="log" aria-live="polite" class="screen-reader-only" v-if="newBranchSelected && newBranchSelected.name">
        <div>{{messages.ariaDataSelected}}: {{newBranchSelected.custom && newBranchSelected.custom.names[locale] ? newBranchSelected.custom.names[locale] : newBranchSelected.name}}</div>
      </span>
      <v-radio-group
        v-model="newBranchSelected"
        :mandatory="false"
        v-for="(branch, index) in orderedBranches"
        :key="branch.id"
        hide-details
        :class="['radio-group', branch === newBranchSelected ? 'selected' : '', focused[index] ? 'radio-group-focused' : '']"
      >
        <v-radio
          class="service-name branch"
          :ripple="true"
          :aria-labelledby="branch.id"
          :value="branch"
          @focus="onFocus(index)"
          @blur="onBlur()"
        >
          <div
            slot="label"
            :id="branch.id"
            :webid="'branchId' + (index + 1) "
            :class="branch === newBranchSelected ? 'selectedColor' : ''"
          >{{branch.custom && locale && branch.custom.names[locale] ? branch.custom.names[locale] : branch.name}}</div>

        </v-radio>
       <small
          :class="branch === newBranchSelected ? 'branch-address selectedColor' : 'branch-address'"
        >{{getBranchAddress(branch, "branchShortAddress")}}</small>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import FormatService from '../services/formatService'

export default {
  name: 'BranchCard',
  mixins: [FormatService],
  props: [
    'branches',
    'bgColor',
    'borderColor',
    'locale',
    'preSelectBranch',
    'regionIndex',
    'onlyRegionRadioActive'
  ],
  data: () => ({
    newBranchSelected: null,
    focused: []
  }),
  computed: {
    ...mapState([
      'messages',
      'funcDebug'
    ]),
    orderedBranches () {
      return [...this.branches].sort((a, b) => {
        var branchNameA = a.name.toLowerCase()
        if (typeof a.custom.names[this.locale] !== 'undefined' && a.custom.names[this.locale] !== '') {
          branchNameA = a.custom.names[this.locale].toLowerCase()
        }
        var branchNameB = b.name.toLowerCase()
        if (typeof b.custom.names[this.locale] !== 'undefined' && b.custom.names[this.locale] !== '') {
          branchNameB = b.custom.names[this.locale].toLowerCase()
        }
        return branchNameA.localeCompare(branchNameB)
      })
    }
  },
  methods: {
    onFocus (index) {
      if (this.funcDebug) console.log('BranchCard:methods:onFocus')
      let newFocused = []
      for (let i = 0; i < this.focused.length; i++) {
        newFocused[i] = false
      }
      newFocused[index] = true
      this.focused = [...newFocused]
    },
    onBlur () {
      if (this.funcDebug) console.log('BranchCard:methods:onBlur')
      let newFocused = []
      for (let i = 0; i < this.focused.length; i++) {
        newFocused[i] = false
      }
      this.focused = [...newFocused]
    }
  },
  watch: {
    newBranchSelected () {
      if (this.funcDebug) console.log('BranchCard:watch:newBranchSelected')
      if (this.newBranchSelected) {
        this.$emit('branch-selected', this.newBranchSelected, this.regionIndex)
      }
    },
    branches () {
      if (this.funcDebug) console.log('BranchCard:watch:branches')
      this.newBranchSelected = null
    },
    onlyRegionRadioActive () {
      if (this.onlyRegionRadioActive !== this.regionIndex) {
        this.newBranchSelected = null
      }
    },
    preSelectBranch () {
      if (this.funcDebug) console.log('BranchCard:watch:preSelectBranch')
      this.newBranchSelected = this.preSelectBranch
    }
  },
  mounted () {
    if (this.funcDebug) console.log('BranchCard:mounted')
    // check the right checkbox in case of preselected branch
    if (this.preSelectBranch) {
      this.newBranchSelected = this.preSelectBranch
    }
    for (let i = 0; i < this.branches.length; i++) {
      this.focused[i] = false
    }
  }
}
</script>
<style scoped lang="scss">
.branch-address {
  padding-left: 54px;
  opacity: 0.9;
}

.branch-list {
  padding: 4px 8px;
}

.branch-list .v-input--radio-group--column .v-radio.service-name {
  margin-bottom: 0;
  margin-left: 22px;
}
.branch-list .radio-group.v-input--radio-group--column {
  margin: 0;
  padding: 14px 0;
  border: solid 1px var(--default-border-color);
  background-color: var(--input-selection-bg-color);
  margin: 5px 0;
}

.v-card{
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
